import { useCallback, useState } from 'react';

export type DeliverySelection = {
    selectedDeliveryIds: string[];
    setSelectedDeliveryIds: React.Dispatch<React.SetStateAction<string[]>>;
    toggleDeliverySelection: (deliveryId: string) => void;
    clearSelection: () => void;
};

// La sélection de livraisons est gérée au-dessus des vues (kanban / timeline / tableau) pour qu'elle
// soit partagée par les trois et qu'elle persiste quand on bascule de l'une à l'autre.
export function useDeliverySelection(): DeliverySelection {
    const [selectedDeliveryIds, setSelectedDeliveryIds] = useState<string[]>([]);

    const toggleDeliverySelection = useCallback((deliveryIdToToggle: string) => {
        setSelectedDeliveryIds((currentIds) =>
            currentIds.includes(deliveryIdToToggle)
                ? currentIds.filter((deliveryId) => deliveryId !== deliveryIdToToggle)
                : [...currentIds, deliveryIdToToggle],
        );
    }, []);

    const clearSelection = useCallback(() => setSelectedDeliveryIds([]), []);

    return { selectedDeliveryIds, setSelectedDeliveryIds, toggleDeliverySelection, clearSelection };
}
